import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Dropdown, Menu } from 'antd';
import styles from './navbarMenu.module.scss';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import {
  checkIsDefaultScheduleChangeRequestor,
  getUserIsMODAdmin,
  getUserPositions,
  getPermittedMenus,
} from '../../store/user/user-reducer';

function NavbarMenu({ routes }: any) {
  const [isVisible, setIsVisible] = useState(false);
  const [current, setCurrent] = useState('0');
  const userPositions = useSelector(getUserPositions);
  const isDefaultScheduleChangeRequestor = useSelector(checkIsDefaultScheduleChangeRequestor);
  const [isHooRequestAllowed, setIsHooRequestAllowed] = useState(false);
  const userIsMODAdmin = useSelector(getUserIsMODAdmin);
  const permittedMenus = useSelector(getPermittedMenus);

  useEffect(() => {
    if (userPositions?.length) {
      setIsHooRequestAllowed(
        userPositions?.includes('RCFD') ||
          userPositions?.includes('AV') ||
          userPositions?.includes('RM') ||
          userPositions?.includes('AM') ||
          isDefaultScheduleChangeRequestor
      );
    } else {
      setIsHooRequestAllowed(isDefaultScheduleChangeRequestor);
    }
  }, [userPositions, isDefaultScheduleChangeRequestor]);

  const menu = (
    <Menu
      onClick={(e) => {
        setIsVisible(false);
        setCurrent(e.key);
      }}
      selectedKeys={[current]}
      className={styles['menu']}
    >
      {(() => {
        const isRouteVisible = (route: any) => {
          if (route.title === 'Hours of Operation Change Request')
            return (
              isHooRequestAllowed ||
              userIsMODAdmin ||
              // Check both new title and old permission name (HOO Accommodations)
              permittedMenus.some(
                (m: string) =>
                  (m || '').toLowerCase() === (route.title || '').toLowerCase() ||
                  (m || '').toLowerCase() === 'hoo accommodations'
              )
            );
          if (route.title === 'User Role Configuration') return userIsMODAdmin;
          if (route.title === 'Branded Fixtures')
            return userIsMODAdmin || permittedMenus.some((m: string) => (m || '').toLowerCase() === 'branded fixtures');
          // // if user is MOD admin, show everything
          // if (userIsMODAdmin) return true;
          // otherwise, check permittedMenus (case-insensitive match)
          return permittedMenus.some((m: string) => (m || '').toLowerCase() === (route.title || '').toLowerCase());
        };

        return routes
          .filter((route: any) => isRouteVisible(route))
          .map((route: any, index: number) => (
            <Menu.Item key={index.toString()} className={styles['menu-item']}>
              <Link to={`${route.path.toLowerCase()}`} className={styles['link']}>
                {route.displayTitle || route.title}
              </Link>
            </Menu.Item>
          ));
      })()}
    </Menu>
  );

  return (
    <StyledDropdown
      overlay={menu}
      trigger={['click']}
      open={isVisible}
      onOpenChange={(visible) => setIsVisible(visible)}
      placement='bottomLeft'
    >
      <Button className={styles['btn-menu']} onClick={(e) => e.preventDefault()}>
        <span className={styles['icon-menu']} />
      </Button>
    </StyledDropdown>
  );
}

export default NavbarMenu;

const StyledDropdown = styled(Dropdown)`
  position: absolute;
  left: 0;
`;
